import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_LIST_TRANSACTION = gql`
  query Transactions($params: TransactionInput!) {
    transactions(params: $params) {
      data {
        id
        type
        direction
        createdAt
        summary
        amount {
          amount
          currency
          formattedAmount
        }
        balance {
          amount
          currency
          formattedAmount
        }
        counterpartyId
        fromAccount
        description
        toAccount
        traceNumber
        reason
        merchant
        paymentMethod
        recurring
        atm
        cardNetwork
        relatedParty
        checkDepositId
        recipientAccountNumber
        recipientName
        senderAccountNumber
        senderName
        # new card attributes
        cardId
        digitalWallet
        ecommerce
        verificationMethod
        merchantName
        merchantLocation
        merchantCategory
        cardPresent
        # new atm attributes
        atmName
        atmLocation
        surcharge {
          amount
          currency
          formattedAmount
        }
        # to account fields
        to {
          accountHolder
          accountNumber
          fullAccountNumber
          routingNumber
        }
        # from account fields
        from {
          accountHolder
          accountNumber
          fullAccountNumber
          routingNumber
        }
        currencyConversion {
          originalCurrency
          amountInOriginalCurrency
          fxRate
        }
        paymentId
        transactionId
        counterpartyId
      }
      pagination {
        offset
        limit
        next
        total
      }
    }
  }
`;

export const GET_STATISTICS_MONEY_IN_OUT = gql`
  query Statistics($params: StatisticsTransactionsInput!) {
    statistics(params: $params) {
      totalTransactions
      totalMoneyIn
      totalMoneyOut
    }
  }
`;
